export default function Brand() {
  return <span className="zg-brand-word">zeitgeist</span>;
}